import * as routes from "../constants/routes";

const REVIEW_BASE = "/review";

export const REVIEW_PATH = `${REVIEW_BASE}/:applicationId`;

export function review(applicationId: string) {
    if (!applicationId) {
        return routes.ORGANIC_LANDING;
    }
    return `${REVIEW_BASE}/${applicationId}`;
}
